<template>
  <div class="select-container">
    <div class="select-input-container" :tabindex="tabindex" @blur="open = false">
      <div id="select-input-selected" @click="open = !open">
        <div class="selected-text">
          {{ selected === 'All' ? adminText('shellAll.all', 'All') : selected }}
        </div>
        <div class="selected-icon-container">
          <img
            class="selected-icon"
            src="/assets/data-table-icons/dropdown-icon.svg"
            :alt="adminText(&quot;shellAll.dropdown&quot;, &quot;Dropdown&quot;)"
          >
        </div>
      </div>
      <div id="select-input-options" :class="{ selectHide: !open, openUp: dropdownUp }">
        <div
          v-for="(option, i) of dropdownOptions"
          :key="i"
          :style="[option === selected && { 'background-color': '#f5f5f5' }]"
          @click="
            selected = option
            open = false
            $emit('input', option)
          "
        >
          {{ option === 'All' ? adminText('shellAll.all', 'All') : option }}
        </div>
      </div>
    </div>
    <div class="text">{{ adminText(&quot;shellAll.rows_per_page&quot;, &quot;rows per page&quot;) }}</div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext],
  name: 'select-dropdown-input',
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: Number,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      dropdownOptions: [...this.options, 'All'],
      selected: this.default ? this.default : _.first(this.options),
      open: false,
      dropdownUp: false,
    }
  },
}
</script>

<style scoped>
.select-container {
  position: relative;
  width: fit-content;
  height: 100%;
  display: flex;
  align-items: center;
}

.select-input-container {
  position: relative;
  width: fit-content;
  height: 100%;
}

#select-input-selected {
  color: #333333;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.selected-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #333333;
}

.selected-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 1rem;
  width: 1rem;
}

.selected-icon {
  height: 1rem;
  width: 1rem;
  filter: invert(66%) sepia(0%) saturate(0%) hue-rotate(99deg) brightness(92%) contrast(92%);
}

#select-input-options {
  color: #333333;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  left: -50%;
  width: fit-content;
  background-color: white;
  box-shadow: 0px 2.5px 5px rgba(51, 51, 51, 0.5);
  margin-bottom: 0.25rem;
  bottom: 100%;
}

#select-input-options.openUp {
  margin-bottom: 0.25rem;
  bottom: 100%;
}

#select-input-options div {
  color: #333333;
  cursor: pointer;
  padding: 0.125rem 1rem;
  user-select: none;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

#select-input-options div:hover {
  background-color: #f5f5f5;
}

.selectHide {
  display: none;
}

.text {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #979797;
  margin-left: 0.5rem;
}
</style>
